export default {
  element: 'datagrid',
  id: 'tutorial-datagrid-2',
  title: 'Apresentações de células e contatos',
  description: 'Exemplos declarativos de células e uma Child Row com DataGrid filha.',
  data: [
    { id: 1, lead: 'Mariana Costa', company: 'LogiTrans Brasil', image: '@EPImages/user.png', classification: 'hot', origin: 'Site', country: 'BR', order: 7 },
    { id: 2, lead: 'Fernanda Alves', company: 'Vértice Engenharia', image: '@EPComponentImages/social-icons/linkedin-com.png', classification: 'warm', origin: 'Indicação', country: 'PT', order: 3 },
    { id: 3, lead: 'Felipe Nunes', company: 'Alfa Distribuição', image: '@EPComponentImages/social-icons/github-com.png', classification: 'cold', origin: 'LinkedIn', country: 'US', order: 9 },
    { id: 4, lead: 'Carlos Nogueira', company: 'Nexa Facilities', image: '@EPComponentImages/social-icons/instagram-com.png', classification: 'warm', origin: 'Evento', country: 'DE', order: 1 },
    { id: 5, lead: 'Aline Rocha', company: 'Supra Foods', image: '@EPImages/user.png', classification: 'hot', origin: 'Site', country: 'FR', order: 6 },
    { id: 6, lead: 'Juliana Martins', company: 'Delta Pharma', image: '@EPComponentImages/social-icons/facebook-com.png', classification: 'hot', origin: 'Indicação', country: 'ES', order: 2 },
    { id: 7, lead: 'Eduardo Lima', company: 'InovaTech Security', image: '@EPComponentImages/social-icons/x-com.png', classification: 'cold', origin: 'LinkedIn', country: 'JP', order: 10 },
    { id: 8, lead: 'Paulo Mendes', company: 'Orion Logística', image: '@EPImages/user.png', classification: 'warm', origin: 'Evento', country: 'CA', order: 4 },
    { id: 9, lead: 'Bianca Souza', company: 'Construmax', image: '@EPComponentImages/social-icons/telegram-me.png', classification: 'warm', origin: 'Site', country: 'MX', order: 8 },
    { id: 10, lead: 'Ricardo Tavares', company: 'Prime Care Saúde', image: '@EPComponentImages/social-icons/whatsapp-com.png', classification: 'hot', origin: 'Indicação', country: 'IT', order: 5 }
  ],
  keys: [{ name: 'id', alias: 'id' }],
  order: [{ field: 'lead', direction: 'ASC' }],
  actions: [],
  search: false,
  pagination: [],
  displayRecords: false,
  header: [
    { id: 'lead', label: 'Lead', sortable: true, mask: { template: 'link', href: 'https://example.com/leads/{id}', target: '_blank' } },
    { id: 'classification', label: 'Ícone', sortable: true, mask: { template: 'icon', icon: { type: 'solid', name: 'star' }, text: '$classification' } },
    { id: 'image', label: 'Imagem', sortable: true, style: { width: '4.25rem', minWidth: '4.25rem' }, mask: { template: 'image', src: '$image', alt: '$company', width: 28 } },
    { id: 'origin', label: 'País', sortable: true, mask: { template: 'flag', flag: '$country' } },
    { id: 'order', label: 'Progresso', sortable: true, mask: { template: 'progress', max: 50, percentual: true } },
    { id: 'order', label: 'Meta', sortable: true, mask: { template: 'progress', max: 50, percentual: false } },
    { id: 'order', label: 'Prioridade', sortable: true, rules: [{ rule: '< 3', color: 'red' }, { rule: '>= 3 && < 6', color: 'yellow' }, { rule: '>= 6', color: 'green' }] }
  ],
  childRow: {
    label: 'Abrir contatos do lead',
    datagrid: {
      element: 'datagrid',
      title: 'Contatos',
      actions: [],
      search: false,
      pagination: [],
      displayRecords: false,
      data: [{ id: 1, name: 'Contato principal', role: 'Comercial' }, { id: 2, name: 'Contato financeiro', role: 'Financeiro' }],
      keys: [{ name: 'id', alias: 'id' }],
      header: [{ id: 'name', label: 'Nome' }, { id: 'role', label: 'Função' }]
    }
  }
};
